/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_4Inputs */



/**
* | output |
* | --- |
* | "Center left" |
*
* @param {Live_Caption_Youtube_Region_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_4 = /** @type {((inputs?: Live_Caption_Youtube_Region_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("centro izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央左")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro esquerdo")
	return /** @type {LocalizedString} */ ("Center left")
});